import { z } from "zod";

export const matrixRowSchema = z.object({ key: z.string().min(1), label: z.string().min(1) });
export const matrixColumnSchema = z.object({ value: z.string().min(1), label: z.string().min(1) });

export const matrixConfigSchema = z.object({
  rows: z.array(matrixRowSchema).default([]),
  columns: z.array(matrixColumnSchema).default([]),
  requireAllRows: z.boolean().default(false),
});

export type MatrixConfig = z.infer<typeof matrixConfigSchema>;
